<template>

	<div class="inbox-body">

		<div class="inbox-header" v-if="studentName">

			<h1 class="page-header">
				{{ studentName }}
				<small class="text-muted">{{ className }}</small>
			</h1>

		</div>

		<div class="inbox-content">

			<div class="row">

				<div class="col-md-12">

					<school-class-list :with-students="true" :label="'Turma:'" />

				</div>

				<div class="col-md-12" v-if="className">

					<label class="control-label" v-translate>Selecione o aluno:</label>
					<students :class="'col-md-12'" :context="'newmessage'" :imglist="true" />

				</div>

				<div class="col-md-12" v-if="studentName">

					<label class="control-label" v-translate>Responsável:</label>

					<div class="form-group" id="responsibles">
						<v-select multiple label="name" :options="responsibles" v-model="responsible" :value="responsibles" placeholder="Selecione os responsáveis:"></v-select>
					</div>

				</div>

				<div class="col-md-12" v-if="studentName">

					<label class="control-label" v-translate>Membro da escola:</label>

					<div class="form-group">

						<div class="form-group" id="schoolMembers">

							<v-select multiple label="formatedName" v-model="member" :options="schoolmembers" :value="schoolmembers" placeholder="Selecione os membros da escola:"></v-select>

						</div>

					</div>

				</div>

				<div class="col-md-12">

					<label class="control-label" v-translate>Assunto:</label>

					<div class="form-group">

						<div class="input-group">

							<span class="input-group-btn">

								<button class="btn default" type="button">
									<i class="icon-pencil"></i>
								</button>

							</span>

							<input class="form-control" type="text" v-model="subject">

						</div>

					</div>

				</div>

				<div class="col-md-12">

					<div class="form-group emoji-text relative">

						<label class="control-label" v-translate>Mensagem:</label>
						<textarea class="form-control" rows="5" v-model="message"></textarea>

						<picker v-show="emojiPickerVisible" class="absolute" :exclude="['flags', 'symbols']" :i18n="i18n" title="Emoji" set="apple" @click="addEmoji"></picker>

					</div>

				</div>

				<div class="col-md-8 text-muted text-right">
					<small v-translate>Para usar <em>emojis</em> clique no botão ao lado.</small><br>
					<small v-translate><strong>Observação:</strong> no navegador os <em>emojis</em> podem aparecer em forma de [], mas ao enviar aparecerá o <em>emoji</em> selecionado.</small>
				</div>

				<div class="col-md-4">

					<div class="btn-group btn-group-justified" role="group">

						<div class="btn-group" role="group">

							<button type="button" class="btn default" @click="emojiPickerVisible = !emojiPickerVisible">
								<emoji emoji="grinning" :size="15"></emoji>
								Emojis
							</button>

						</div>

						<div class="btn-group" role="group">

							<button class="btn green-jungle" @click="sendNewMessage">
								<i class="fa fa-paper-plane-o" aria-hidden="true"></i>
								Enviar
							</button>

						</div>

					</div>

				</div>

			</div>

		</div>

	</div>

</template>

<style lang="scss" scoped>

	.inbox-body {
		background: #fff;
		border: 0;
	}

</style>

<script>

	import MessageNew from './';
	export default MessageNew;

</script>



// WEBPACK FOOTER //
// main.vue?b3a6e730